import { accordionGql } from '../landing_page_2023/accordionGql.js';
import { basicText2023Gql } from '../landing_page_2023/basicTextGql.js';
import { chart2023Gql } from '../landing_page_2023/chartGql.js';
import { contentGridGql } from '../landing_page_2023/contentGridGql.js';
import { contentSectionGql } from '../landing_page_2023/contentSectionGql.js';
import { cSPromoBlock2023Gql } from '../landing_page_2023/cSPromoBlockGql.js';
import { disclaimerFootnote2023Gql } from '../landing_page_2023/disclaimerFootnoteGql.js';
import { embeddedImageGalleryGql } from '../landing_page_2023/embeddedImageGalleryGql.js';
import { featuredContent2023Gql } from '../landing_page_2023/featuredContentGql.js';
import { featuredProductsGql } from '../landing_page_2023/featuredProductsGql.js';
import { form2023Gql } from '../landing_page_2023/formGql.js';
import { heroBanner2023Gql } from '../landing_page_2023/heroBannerGql.js';
import { imageGridGql } from '../landing_page_2023/imageGridGql.js';
import { interactiveDemo2023Gql } from '../landing_page_2023/interactiveDemoGql.js';
import { interactiveWebglDemo2023Gql } from '../landing_page_2023/interactiveWebglDemoGql.js';
import { linksGql } from '../landing_page_2023/linksGql.js';
import { locationFinder2023Gql } from '../landing_page_2023/locationFinderGql.js';
import { pageHeader2023Gql } from '../landing_page_2023/pageHeaderGql.js';
import { productHeader2023Gql } from '../landing_page_2023/productHeaderGql.js';
import { productHeaderGalleryGql } from '../landing_page_2023/productHeaderGalleryGql.js';
import { productHeaderPremiumGql } from '../landing_page_2023/productHeaderPremiumGql.js';
import { productHeaderStandardGql } from '../landing_page_2023/productHeaderStandardGql.js';
import { promoBlockGql } from '../landing_page_2023/promoBlockGql.js';
import { quoteSlider2023Gql } from '../landing_page_2023/quoteSliderGql.js';
import { relatedProductsGql } from '../landing_page_2023/relatedProductsGql.js';
import { relatedResources2023Gql } from '../landing_page_2023/relatedResourcesGql.js';
import { soundCloudGql } from '../landing_page_2023/soundCloudGql.js';
import { tabs2023Gql } from '../landing_page_2023/tabs2023Gql.js';
import { textAndContent2023Gql } from '../landing_page_2023/textAndContentGql.js';
import { textAndIconCard2023Gql } from '../landing_page_2023/textAndIconCardsGql.js';
import { textAndImage2023Gql } from '../landing_page_2023/textAndImageGql.js';
import { textContentCardsStandaloneGql } from '../landing_page_2023/textContentCardsStandaloneGql';
import { videoEmbedGql } from '../landing_page_2023/videoEmbedGql.js';
import { videoGallery2023Gql } from '../landing_page_2023/videoGalleryGql.js';
import { videoPlayer2023Gql } from '../landing_page_2023/videoPlayerGql.js';
import { videoPlayerLegacyGql } from '../landing_page_2023/videoPlayerLegacyGql.js';

export const landingPageContent2023Gql = `
navigationTheme
pageTheme
displayBreadcrumbs
${contentSectionGql}
landingPageContent2023 {
  ${accordionGql}
  ${basicText2023Gql}
  ${chart2023Gql}
  ${contentGridGql}
  ${cSPromoBlock2023Gql}
  ${disclaimerFootnote2023Gql}
  ${embeddedImageGalleryGql}
  ${featuredContent2023Gql}
  ${featuredProductsGql}
  ${form2023Gql}
  ${heroBanner2023Gql}
  ${imageGridGql}
  ${interactiveDemo2023Gql}
  ${interactiveWebglDemo2023Gql}
  ${linksGql}
  ${locationFinder2023Gql}
  ${pageHeader2023Gql}
  ${productHeader2023Gql}
  ${productHeaderGalleryGql}
  ${productHeaderPremiumGql}
  ${productHeaderStandardGql}
  ${promoBlockGql}
  ${quoteSlider2023Gql}
  ${relatedProductsGql}
  ${relatedResources2023Gql}
  ${soundCloudGql}
  ${tabs2023Gql}
  ${textAndContent2023Gql}
  ${textAndIconCard2023Gql}
  ${textAndImage2023Gql}
  ${textContentCardsStandaloneGql}
  ${videoEmbedGql}
  ${videoGallery2023Gql}
  ${videoPlayer2023Gql}
  ${videoPlayerLegacyGql}
}`;
